import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
    width: 100%;
    padding: 1rem;
    min-height: 20.625rem;
    max-height: 20.625rem;

    display: flex;
    flex-direction: column;
    overflow: hidden;

    border-radius: 0.75rem;
    background-color: #f8f8f9;
    border: 0.3rem solid #f8f8f9;

    @media (max-width: 1320px) {
        max-width: 64.875rem;
    }

    @media (max-width: 768px) {
        max-width: 100%;
        min-height: 180px;
        max-height: 180px;
        overflow: visible;
    }
`;

export const CardsScroll = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: scroll;

    ::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
        overflow-y: hidden;
        overflow-x: scroll;
        gap: 0.75rem;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    
    justify-content: space-between;
`;

export const ViewAll = styled.a`
    gap: 0.2rem;
    display: flex;
    text-align: end;
    align-items: center;
    flex-direction: row;
    
    color: #589bff;
    cursor: pointer;
    letter-spacing: 0.1rem;
    
    > img {
        position: flex;
        
        @media (max-width: 333px) {
            margin-left: 2.5rem;   
        }
    }

    > p {
      
      @media (max-width: 333px) {
            font-size: 0.45rem;   
        }
    } 
`;

export const EventCard = styled.div`
    padding: 0.8rem;
    position: relative;

    display: flex;
    flex-direction: column;
    gap: 0.3rem;

    border-radius: 0.5rem;
    margin-bottom: 0.75rem;
    background-color: white;

    @media (max-width: 768px) {
        width: 85%;
        min-width: 85%;
        max-width: 85%;
        height: fit-content;
        flex-shrink: 0;
        margin-bottom: 0;
    }
`;

export const EventInfo = styled.div`
    display: flex;
    gap: 5px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const EventMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
    flex: 1;
`;

export const NomeComercialScroll = styled.div`
    overflow-x: auto;

    p {
        white-space: nowrap;
    }

    ::-webkit-scrollbar {
        width: 0px;
        height: 4px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 8px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

export const FieldScroll = styled.div`
    max-width: 60%;
    overflow-x: auto;

    p {
        white-space: nowrap;
    }

    ::-webkit-scrollbar {
        width: 0px;
        height: 4px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 8px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

export const EventTitle = styled.h4`
    width: 100%;
    overflow: hidden;
    max-height: 40px;
    
    margin: 0;
    
    font-size: 1rem;
    color: ${theme.colors.gray.Cinza_2};
    font-weight: bold;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
 
    @media (max-width: 376px) {
        font-size: 0.7rem;    
    }
`;

export const Mark = styled.p`
    font-size: 0.875rem;
`;

export const EventLocation = styled.p`
    max-width: 7.5rem;
    padding: 0.5rem;
    
    gap: 0.2rem;
    display: flex;
    margin: 0.25rem 0;
    
    color: #589bff;
    font-weight: 800;
    font-size: 0.65rem;
    align-items: center;
    border-radius: 999px;
    background-color: #F3F3F5;
  
`;

export const EventDate = styled.span`
    color: #888;
    font-size: 0.55rem;
    letter-spacing: 0.1rem;

    @media (max-width: 376px) {
        font-size: 0.45rem;    
    }
`;

export const TypeToxic = styled.p`
    color: ${theme.colors.gray.Cinza_2};
    font-weight: 600;
    font-size: .5625rem;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    
    @media (max-width: 376px) {
        font-size: 0.45rem;      
    }
`;

export const Active = styled.p`
    color: #8A92A2;
    font-size: 0.5625rem;
    letter-spacing: 0.1rem;

    white-space: nowrap;
    overflow-x: auto;
    max-width: 100%;

    ::-webkit-scrollbar {
        width: 0px;
        height: 3px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 8px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    @media (max-width: 376px) {
        font-size: 0.5625rem;
        text-align: end;
    }
`;

export const FarmWrapper = styled.div`
    display: flex;
    width: 50%;
    min-width: 0;
    text-align: end;
    align-items: flex-end;
    flex-direction: column;
    flex-shrink: 0;
    gap: 0.25rem;
`;